import InfoModal from '@/components/ui/InfoModal';
import { ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useBranding } from '@/contexts/BrandingContext';
import { useVideoBySlug } from '@/hooks/useVideos';

function InfoDialog() {
  const { isWhiteLabel } = useBranding();
  const SubmitTicketSupportVideo = useVideoBySlug('submit-ticket-support');
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleVideoLinkClick = () => {
    setIsOpen(false);
    navigate('/dashboard/resources#submit-ticket-support');
  };

  return (
    <InfoModal 
      title="How to Submit a Ticket"
      open={isOpen}
      onOpenChange={setIsOpen}
      description={
        <div className="space-y-4">
          <p className="text-sm text-gray-700 mb-4">
            Learn how to submit tickets, report bugs, request features, and get support through the floating blue button.
          </p>

          {SubmitTicketSupportVideo &&<button 
            className='text-blue-500 font-bold flex items-center gap-2 hover:text-blue-700 transition-colors'
            onClick={handleVideoLinkClick}
          >
            Watch the video instructions <ExternalLink className='size-4' />
          </button>}
          
          {!isWhiteLabel && <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://www.loom.com/embed/0a0b82db690842ff9f0e7a84ccc5111e?sid=b84d2bf8-5e46-4045-8bfd-94e45562c111"
              frameBorder="0"
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
            />
          </div>}


          <div className="space-y-3">
            <div>
              <h4 className="font-medium mb-1">How to Access Support:</h4>
              <ul className="text-sm space-y-1 text-gray-600">
                <li>• <strong>Blue Button:</strong> Located in the bottom right corner of every page</li>
                <li>• <strong>Click to Open:</strong> Opens a popup with different ticket types</li>
                <li>• <strong>Always Available:</strong> Accessible from anywhere in the app</li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-medium mb-1">Ticket Types:</h4>
              <ul className="text-sm space-y-1 text-gray-600">
                <li>• <strong>Feature Request:</strong> Request new features or integrations</li>
                <li>• <strong>Bug Report:</strong> Report issues with screenshots and details</li>
                <li>• <strong>General Feedback:</strong> Share thoughts about the app</li>
                <li>• <strong>Integration Request:</strong> Request specific calendar or tool integrations</li>
              </ul>
            </div>
          </div>
        </div>
      }
      triggerClassName="ml-2"
    />
  )
}

export default InfoDialog